import { HttpEvent, HttpHandlerFn, HttpRequest } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';

export const authInterceptor: (
  onError: () => void
) => (httpRequest: HttpRequest<unknown>, next: HttpHandlerFn) => Observable<HttpEvent<unknown>> =
  (onError: () => void) => (httpRequest: HttpRequest<unknown>, next: HttpHandlerFn) =>
    next(httpRequest).pipe(
      catchError((e) => {
        if (e.status === 401) {
          onError();
        }
        return throwError(() => e);
      })
    );
